import styles from './media.module.sass'
import get from 'lodash/get'

import classNames from 'classnames'

import BlockWrapper from '../layout/block_wrapper'
import Image from './image'
import Video from './video'
import Lottie from './lottie'

function Media(props) {
	let fields = null
	if(props.layout_settings){
		fields =  props.fields || null
	} else {
		fields = props.fields || props
	}

	function renderMedia() {
		if(fields.media_type == 'image'){
			return <>
				<Image {...fields.image} settings={props.settings} alignment={props.vertical_alignment + ' ' + props.horizontal_alignment} sizeOverride={props.sizeOverride}  className={props.className} />
				{fields.mobile_image && <Image {...fields.mobile_image} mobile={true} settings={props.settings} alignment={props.mobile_vertical_alignment + ' ' + props.mobile_horizontal_alignment} className={classNames(props.className, styles.mobile)} />}
			</>
		}
		if(fields.media_type == 'video'){
			return <>
				<Video videoRef={props.videoRef} fields={fields} settings={fields.settings} className={fields.className} />
			</>
		}
		if(fields.media_type == 'lottie'){
			return <>
				<Lottie {...fields.lottie} settings={fields.settings} className={fields.className} />
			</>
		}
	}
	if(props.layout_settings){
		return <BlockWrapper {...props} className={classNames(styles.media, fields?.mobile == true ? styles.mobile_version : '', fields?.className, styles[fields?.custom_class])}>
			{renderMedia()}
		</BlockWrapper>
	} else {
		return renderMedia()
	}
}

export default Media